module.exports = __webpack_public_path__ + "img/approve.5287c8de.svg";